import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight } from 'lucide-react';

const ServiceCard = ({ service, vendorRating, category }) => {
  const imageUrl = service.image_url || service.vendor_profile?.image_url || service.vendor_profile?.user?.profile_image_url;

  return (
    <Link
      to={`/services/${service.id}`}
      className="group block"
    >
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg hover:border-black active:shadow-md transition-all duration-300 h-full flex flex-col">
        {/* Service Image */}
        <div className="relative w-full h-32 sm:h-36 md:h-40 bg-black overflow-hidden">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={service.service_name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <div className="text-center text-white/50">
                <div className="w-16 h-16 border-2 border-white/30 rounded-lg mx-auto mb-2 flex items-center justify-center">
                  <span className="text-white/30 text-2xl">📷</span>
                </div>
              </div>
            </div>
          )}
          
          {/* Category Badge */}
          {category && (
            <div className="absolute top-1.5 left-1.5 sm:top-2 sm:left-2 bg-black text-white px-1.5 sm:px-2 py-0.5 rounded-full text-[9px] sm:text-[10px] font-light">
              {category.category_name}
            </div>
          )}

          {/* Rating Badge */}
          {vendorRating && (
            <div className="absolute top-1.5 right-1.5 sm:top-2 sm:right-2 bg-white/90 backdrop-blur-sm text-black px-1.5 sm:px-2 py-0.5 rounded-full text-[9px] sm:text-[10px] font-medium flex items-center gap-0.5">
              <Star className="w-2 h-2 sm:w-2.5 sm:h-2.5 fill-current" />
              <span>{vendorRating}</span>
            </div>
          )}
        </div>

        {/* Service Info */}
        <div className="p-2.5 sm:p-3 md:p-3.5 flex-1 flex flex-col">
          <h3 className="font-medium text-black text-sm sm:text-base md:text-lg mb-1.5 sm:mb-2 group-hover:text-gray-700 transition-colors line-clamp-2">
            {service.service_name}
          </h3>

          <p className="text-gray-600 text-[11px] sm:text-xs md:text-sm mb-2 sm:mb-3 line-clamp-2 flex-1 leading-snug">
            {service.description || 'Professional service for your special events.'}
          </p>

          {/* Footer */}
          <div className="flex items-center justify-between pt-2 sm:pt-2.5 border-t border-gray-100">
            <div className="flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-600">
              <span className="font-light">Starting from</span>
            </div>
            
            <div className="flex items-center gap-1 sm:gap-1.5">
              <span className="text-sm sm:text-base md:text-lg font-medium text-black">
                ${service.base_price || 'Contact'}
              </span>
              <ArrowRight className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-gray-400 group-hover:text-black group-hover:translate-x-1 transition-all flex-shrink-0" />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;

